import { render, staticRenderFns } from "./SilencedAlert.vue?vue&type=template&id=67f7589b&scoped=true&"
var script = {}
import style0 from "./SilencedAlert.vue?vue&type=style&index=0&id=67f7589b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f7589b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f7589b')) {
      api.createRecord('67f7589b', component.options)
    } else {
      api.reload('67f7589b', component.options)
    }
    module.hot.accept("./SilencedAlert.vue?vue&type=template&id=67f7589b&scoped=true&", function () {
      api.rerender('67f7589b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/SilencedAlert.vue"
export default component.exports